<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-card style="margin-bottom: 20px;">
            <template #header>
                <div class="card-header">
                    <span>设备激活补贴</span>
                </div>
            </template>
            <el-table :data="deviceCommissionList" :row-key="deviceCommissionRowKey" style="width: 100%">
                <el-table-column prop="partner_code" label="商户CODE" />
                <el-table-column prop="model_code" label="产品型号" />
                <el-table-column label="颗粒度" width="100">
                    <template #default="scope">
                        <!-- 大洲码与国家码会撞车(AS/AF/NA/SA)，必须按 granularity 区分展示 -->
                        <el-tag :type="Number(scope.row.granularity) === GRANULARITY.COUNTRY ? 'warning' : 'success'"
                            size="mini">
                            {{ granularityLabel(scope.row.granularity) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="区域">
                    <template #default="scope">
                        {{ regionDisplayName(scope.row.region, scope.row.region_name) }}
                    </template>
                </el-table-column>
                <el-table-column prop="commission_rate" label="补贴" />
                <el-table-column prop="currency" label="币种" />
                <el-table-column label="是否真实结算">
                    <template #default="scope">
                        {{ scope.row.is_settlement === 0 ? '否' : '是' }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card style="margin-bottom: 20px;">
            <template #header>
                <div class="card-header">
                    <span>订单佣金</span>
                </div>
            </template>
            <el-table :data="orderCommissionList" style="width: 100%">
                <el-table-column prop="partner_code" label="商户CODE" />
                <el-table-column prop="model_code" label="产品型号" />
                <el-table-column prop="region" label="区域" />
                <el-table-column prop="commission_rate" label="佣金比例" />
                <el-table-column label="是否真实结算">
                    <template #default="scope">
                        {{ scope.row.is_settlement === 0 ? '否' : '是' }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card style="margin-bottom: 20px;">
            <template #header>
                <div class="card-header">
                    <span>设备生产补贴</span>
                </div>
            </template>
            <el-table :data="deviceFactorySubsidyList" style="width: 100%">
                <el-table-column prop="partner_code" label="商户CODE" />
                <el-table-column prop="model_code" label="产品型号" />
                <el-table-column prop="amount_cny" label="补贴" />
                <el-table-column prop="currency" label="币种" />
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../../axios/api'
import {
    GRANULARITY,
    granularityLabel,
    regionDisplayName
} from '../../../util/salesPartner'
export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const deviceCommissionList = ref([])
        const orderCommissionList = ref([])
        const deviceFactorySubsidyList = ref([])

        console.log('route -->', route)

        const goback = () => {
            router.go(-1)
        }

        // 行 key：region 会跨颗粒度重复，必须拼上 currency + granularity
        const deviceCommissionRowKey = (row) =>
            `${row.region}_${row.currency}_${row.granularity}`

        const getSalesPartnerModelDeviceCommissionList = ({ partner_code, model_code }) => {
            return api.SalesPartnerModelDeviceCommissionList({ partner_code, model_code }).then(res => {
                if (res.data.code === 200) {
                    deviceCommissionList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取详情失败:', err)
                ElMessage.error('获取详情失败')
            })
        }

        const getSalesPartnerModelOrderCommissionList = ({ partner_code, model_code }) => {
            return api.SalesPartnerModelOrderCommissionList({ partner_code, model_code }).then(res => {
                if (res.data.code === 200) {
                    orderCommissionList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取详情失败:', err)
                ElMessage.error('获取详情失败')
            })
        }

        const getDeviceFactorySubsidyList = ({ partner_code, model_code }) => {
            return api.SalesPartnerModelDeviceFactorySubsidyList({ partner_code, model_code }).then(res => {
                if (res.data.code === 200) {
                    deviceFactorySubsidyList.value = res.data.data
                }
            }).catch(err => {
                console.error('获取详情失败:', err)
                ElMessage.error('获取详情失败')
            })
        }

        onMounted(() => {
            const partner_code = route.params.partner_code
            const model_code = route.params.model_code
            if (partner_code && model_code) {
                getSalesPartnerModelDeviceCommissionList({ partner_code, model_code })
                getSalesPartnerModelOrderCommissionList({ partner_code, model_code })
                getDeviceFactorySubsidyList({ partner_code, model_code })
            }
        })

        return {
            goback,
            deviceCommissionList,
            orderCommissionList,
            deviceFactorySubsidyList,
            getSalesPartnerModelOrderCommissionList,
            getSalesPartnerModelDeviceCommissionList,
            getDeviceFactorySubsidyList,
            deviceCommissionRowKey,
            GRANULARITY,
            granularityLabel,
            regionDisplayName
        }
    }
}
</script>